import React, { useEffect, useState, useRef, useCallback } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DataGrid, ToolBar } from "..";
import { columns } from "./columns";
//import { GridPagination } from "@mui/x-data-grid-pro";
import dayjs from "dayjs";
import api from "../../services/api";
import ImportModal from "./ImportModal";
import SourceDomainModal from "./SourceDomainModal";
import userPermission from "../../utils/userPermission";
import CustomBreadcrumbs from "../common/CustomBreadcrumbs";
import { useLocation } from "react-router-dom";
import { Modal } from "../../components";
//import { MdAddCircleOutline, MdRemoveCircleOutline } from "react-icons/md";
import AlreadyAssignErrorModal from "./AlreadyAssignErrorModal";
import { FormControl } from "@mui/material";
import AutoComplete from "./AutoComplete";
import debounce from "lodash/debounce";
import ImportUpdateExcelModal from "./ImportUpdateExcelModal";
import AddUpdateForm from "./AddUpdateForm";
import StartBrowser from "./StartBrowser";
import { osName } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  setIsBrowserActive,
  setIsBrowserDomain,
} from "../../store/slices/authSlice";
import { FaCheck } from "react-icons/fa";
import SaveFilterModal from "../../pages/Domains/SaveFilterModal";
import FiltersDropdown from "../../pages/Domains/FiltersDropdown";
import _ from "lodash";
export default function BacklinksTable() {
  // const [backlinkFilters, setBacklinkFilter] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const location = useLocation();
  const { selectedUser, module } = location.state || {};
  const [backlinksData, setBacklinksData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [keyToDelete, setKeyToDelete] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [selectededitRow, setselectedEditRow] = useState("");
  //const [states, setStates] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [selectedData, setSelectedData] = useState([]);
  const [isAlreadyAssignModal, setAlreadyAssignErrorModal] = useState(false);
  const [openBacklink, setopenBacklink] = useState(false);
  const [editingRecord, setEditingRecord] = useState({});
  const [openStartBrowser, setOpenStartBrowser] = useState(false);
  const [isExistCobmiErrors, setExistCombiErros] = useState([]);
  const [queryOptions, setQueryOptions] = React.useState({
    groupOp: "",
    rules: [],
  });
  const queryParams = new URLSearchParams(location.search);
  const reviewTask = queryParams.get("review_task_page");
  // Modal
  const [domains, setDomains] = useState([]);
  const [assignedStatus, setAssignedStatus] = useState("");
  const [isSourceDomain, setIsSourceDomain] = useState(true);
  const [toggleStates, setToggleStates] = useState({});
  const [savedFilters, setSavedFilters] = useState(null);
  const [isFilterSave, setIsFilterSave] = useState(false);
  const handleModal = (data) => {
    setIsSourceDomain(!isSourceDomain);
    setDomains(data);
  };
  const [backlinkCount, setBacklinkCount] = useState({
    totalBacklinks: 0,
    assignedBacklinks: 0,
    unassignedBacklinks: 0,
  });
  const [backlinksTypeList, setBacklinksTypeList] = useState([]);
  const [backlinksStatusList, setBacklinksStatusList] = useState([]);
  const [nicheProductList, setNicheProductList] = useState([]);
  const followStatus = [
    { value: "Nofollow", label: "Nofollow" },
    { value: "Dofollow", label: "Dofollow" },
    { value: "Pending", label: "Pending" },
  ];
  const locationTypes = [
    { value: "local", label: "Local" },
    { value: "national", label: "National" },
  ];
  const [showCategoryTooltip, setCategoryShowTooltip] = useState(null);
  const [showLocationTooltip, setLocationShowTooltip] = useState(null);

  const cancelButtonRef1 = useRef(null);
  const cancelBacklinkButtonRef = useRef(null);

  const handleBacklinkModal = () => {
    setopenBacklink(!openBacklink);
  };
  const handleAlreadyAssignModal = () => {
    setAlreadyAssignErrorModal(!isAlreadyAssignModal);
  };

  useEffect(() => {
    if (backlinksData && backlinksData.backlinksData) {
      const initialStates = {};
      backlinksData.backlinksData.forEach((item) => {
        let bid = item["b.id"];
        initialStates[bid] = item["b.good_to_assign"] === 1;
      });
      setToggleStates(initialStates);
    }
  }, [backlinksData]);

  const handleToggle = (params) => {
    setToggleStates((prev) => {
      const currentState =
        prev[params?.id] !== undefined
          ? prev[params?.id]
          : backlinksData?.backlinksData?.find((item) => item.id === params?.id)
              ?.b.good_to_assign === 1;

      const newState = !currentState;
      goodToAssignUpdate(
        params?.id,
        newState,
        params?.row["b.backlink_domain"]
      );
      return {
        ...prev,
        [params?.id]: newState,
      };
    });
  };
  const goodToAssignUpdate = async (bid, newState, backlink_domain) => {
    setIsLoading(true);
    let selectedData = rows.find((e) => e["b.id"] === bid);
    selectedData = { ...selectedData, "b.good_to_assign": newState ? 1 : 0 };
    try {
      const res = await api.put(
        `/api/backlinks/updateBacklink`,
        {
          id: selectedData["b.id"],
          backlink_domain: selectedData["b.backlink_domain"],
          signup_url: selectedData["b.signup_url"] || "",
          backlink_location_type: selectedData["b.backlink_location_type"],
          backlink_type_id: selectedData["b.backlink_type_id"],
          domain_rating: selectedData["b.domain_rating"],
          ready_status_id: selectedData["b.ready_status_id"],
          follow_status: selectedData["b.follow_status"],
          backlink_rank: selectedData["b.backlink_rank"],
          traffic: selectedData["b.traffic"],
          good_to_assign: selectedData["b.good_to_assign"],
          niche_product_ids: selectedData["b.niche_product_ids"],
          location_type: selectedData["b.location_type"],
          location_ids: JSON.parse(selectedData["b.location_ids"]) ?? [
            JSON.parse(selectedData.records["b.location_ids"]),
          ],
          backlink_paid_status: selectedData["b.backlink_paid_status"],
        }
        // {
        //   goodToAssign: newState,
        //   id: bid,
        //   backlink_domain: backlink_domain,
        // }
      );
      if (res.status === 200 || res.status === 201) {
        toast.success("Good To Assign Status Changed");
        /* fetchBacklinksData({
          size: paginationModel.pageSize,
          page: paginationModel.page,
          filter: queryOptions,
        }); */
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  const handleTaskLink = (backlinkId, task_status, domain) => {
    const stateData = {
      backlink_id: backlinkId,
      task_status: task_status,
      domain,
    };
    const queryString = new URLSearchParams(stateData).toString();
    const baseUrl =
      user?.user?.role_id === 8
        ? `/reports/review-task?${queryString}`
        : `/backlink_detail?${queryString}`;

    window.open(baseUrl, "_blank");
  };

  const onSelectAll = (checked) => {
    if (checked) {
      const updatedArray = backlinksData?.backlinksData?.map((item) => item);
      setSelectedData(updatedArray);
    } else {
      setSelectedData([]);
    }
  };
  const isSelected = (data) => {
    return selectedData.some((item) => item["b.id"] === data["b.id"]);
  };
  const onSingleSelect = ({ checked, data }) => {
    try {
      if (checked) {
        setSelectedData((prevSelectedData) => {
          const updatedSelectedData = [...prevSelectedData, data];
          return updatedSelectedData;
        });
      } else {
        setSelectedData((prevSelectedRecord) => {
          const updatedSelectedRecord = prevSelectedRecord?.filter(
            (item) => item["b.id"] !== data["b.id"]
          );
          return updatedSelectedRecord;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [isLocation, setLocationdata] = useState([]);
  const [isAutoComLoader, setAutoComLoader] = useState(false);
  /* const initalData = {
    id: "",
    name: "",
  }; */
  const [selectedPayload, setSelectedPayload] = useState({});
  const [domain, setDomain] = useState({});
  const handleSelectDomain = (item) => {
    setDomain({
      name: item?.name,
      id: item?.id,
    });
  };
  const handleSelect = (item, rowId) => {
    setSelectedPayload({
      name: item?.name,
      id: item?.id,
    });
    const updatedRows = backlinksData?.backlinksData?.map((row) =>
      row["b.id"] === rowId ? { ...row, "b.location_ids": item?.id } : row
    );
    if (updatedRows) {
      setBacklinksData({ ...backlinksData, backlinksData: updatedRows });
    }
  };

  const fetchData = useCallback(async (searchQuery, PreLocationType) => {
    setLocationdata([]);
    if (searchQuery?.length === 0) {
      setLocationdata([]);
      return;
    }
    const payload = {
      filters: {
        groupOp: "AND",
        rules: [
          {
            field: "name",
            op: "cn",
            data: searchQuery,
          },
        ],
      },
    };
    setAutoComLoader(true);
    try {
      let newLocationType = PreLocationType ?? "city";
      let endpoint = "/api/locations";
      if (newLocationType === "country") {
        endpoint += "/countries";
      } else if (newLocationType === "state") {
        endpoint += "/states";
      } else if (newLocationType === "city") {
        endpoint += "/cities ";
      }
      const res = await await api.post(endpoint, payload);
      if (res.status === 200 || res.status === 201) {
        setLocationdata(
          res?.data?.map((item) => ({
            id: item.id,
            name: item.name,
          }))
        );
      }
    } catch (err) {
      console.log(err);
    }
    setAutoComLoader(false);
  }, []);
  // eslint-disable-next-line
  const handleQueryChange = useCallback(
    debounce((newQuery, PreLocationType) => {
      fetchData(newQuery, PreLocationType);
    }, 500),
    []
  );

  const resetPayload = () => {
    setSelectedPayload({
      name: "",
      id: "",
    });
  };

  const renderLocationDataEdit = (params) => {
    const { id } = params;
    return (
      <FormControl fullWidth>
        <AutoComplete
          data={isLocation}
          idField="id"
          valueField="name"
          onSelect={handleSelect}
          onQueryChange={handleQueryChange}
          placeholder="Search ..."
          setAutoComLoader={setAutoComLoader}
          isAutoComLoader={isAutoComLoader}
          //selectedItem={selectedPayload?.domain_data}
          selectedItem={selectedPayload}
          extraClass="mt-1"
          rowId={id}
          PreLocationType={params?.row["b.location_type"]}
          setLocationdata={setLocationdata}
          //backlinksData={backlinksData?.backlinksData}
        />
      </FormControl>
    );
  };
  const columnDefs = columns({
    handleModal: handleModal,
    backlinksTypeList: backlinksTypeList,
    backlinksStatusList: backlinksStatusList,
    followStatus: followStatus,
    handleTaskLink: handleTaskLink,
    handleToggle: handleToggle,
    toggleStates: toggleStates,
    backlinksData: backlinksData?.backlinksData,
    selectedData: selectedData,
    onSelectAll: onSelectAll,
    isSelected: isSelected,
    onSingleSelect: onSingleSelect,
    isLoading: isLoading,
    nicheProductList: nicheProductList,
    //renderLocationTypeEdit,
    locationTypes,
    renderLocationDataEdit,
    showCategoryTooltip,
    setCategoryShowTooltip,
    showLocationTooltip,
    setLocationShowTooltip,
    roleId: user?.user?.role_id,
  });
  const [isImport, setIsImport] = useState(true);
  const [isExcelImport, setIsExcelImport] = useState(true);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 1,
  });

  const getBacklinkStatusList = () => {
    setIsLoading(true);
    api
      .get(`/api/backlinks/backlink_status_list`)
      .then((res) => setBacklinksStatusList(res.data))
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };
  //   Get Type List
  const getBacklinkTypeList = () => {
    setIsLoading(true);
    api
      .get(`/api/backlinks/backlink_type_list`)
      .then((res) => setBacklinksTypeList(res.data))
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  const getNicheProductList = () => {
    setIsLoading(true);
    api
      .get(`/api/backlinks/niche_products`)
      .then((res) => setNicheProductList(res.data))
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };
  useEffect(() => {
    getBacklinkTypeList();
    getBacklinkStatusList();
    getNicheProductList();
  }, []);
  function modifyRules(query) {
    if (!query.rules?.length) return query;
    query.rules = query.rules?.flatMap((rule) => {
      if (rule.field === "b.created_at" && rule.op === "eq") {
        const dateStr = rule.data.replace(/'/g, ""); // Remove single quotes
        const date = new Date(dateStr);

        const startOfDay = new Date(date);
        startOfDay.setHours(0, 0, 0, 0);
        const startISO = startOfDay.toISOString(); // "2025-02-19T19:00:00.000Z"

        const endOfDay = new Date(date);
        endOfDay.setHours(23, 59, 59, 999);
        const endISO = endOfDay.toISOString(); // "2025-02-20T18:59:59.999Z"

        return [
          { field: "b.created_at", op: "gte", data: `'${startISO}'` },
          { field: "b.created_at", op: "lte", data: `'${endISO}'` },
        ];
      }
      if (rule.field === "ub.created_at" && rule.op === "eq") {
        const dateStr = rule.data.replace(/'/g, ""); // Remove single quotes
        const date = new Date(dateStr);

        const startOfDay = new Date(date);
        startOfDay.setHours(0, 0, 0, 0);
        const startISO = startOfDay.toISOString(); // "2025-02-19T19:00:00.000Z"

        const endOfDay = new Date(date);
        endOfDay.setHours(23, 59, 59, 999);
        const endISO = endOfDay.toISOString(); // "2025-02-20T18:59:59.999Z"

        return [
          { field: "ub.created_at", op: "gte", data: `'${startISO}'` },
          { field: "ub.created_at", op: "lte", data: `'${endISO}'` },
        ];
      }
      return rule;
    });

    return query;
  }

  const fetchBacklinksData = async (payload) => {
    payload.user_id = selectedUser?.id ? selectedUser?.id : user?.user?.id;
    /* payload.is_assigned = true;
    payload.assigned_user_id = selectedUser?.id || ""; */
    if (reviewTask === "true" && userPermission("Backlink Report")) {
      payload.review_task_page = true;
    }
    setIsLoader(true);
    setBacklinksData([]);
    const { page, perPage, filter } = payload;
    api
      .post(`${process.env.REACT_APP_PUBLIC_API}/api/backlinks/`, {
        page,
        perPage,
        ...payload,
        ...(filter?.rules?.length ? { filter: modifyRules(filter) } : {}),
      })
      .then((response) => {
        setBacklinksData(response?.data);
        setBacklinkCount(response?.data?.user_backlink_count?.[0] ?? 0);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error?.response?.data?.message);
      })
      .finally(() => {
        setIsLoader(false);
      });
  };
  // const fetchBacklinksFilter = async (payload) => {
  //   setIsLoading(true);
  //   api
  //     .get(
  //       `${process.env.REACT_APP_PUBLIC_API}/api/backlinks/backlinkFilterList`,
  //       payload
  //     )
  //     .then((response) => {
  //       setBacklinkFilter(response.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };
  const fetchStates = async () => {
    setIsLoading(true);
    /*   api
      .get(`${process.env.REACT_APP_PUBLIC_API}/api/location/stateList`)
      .then((response) => {
        setStates(response?.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      }); */
  };
  useEffect(() => {
    fetchBacklinksData({
      page: paginationModel?.page,
      perPage: paginationModel?.pageSize,
      filters: queryOptions,
    });
    // fetchBacklinksFilter();
    fetchStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  const refreshBacklinksData = () => {
    fetchBacklinksData({
      page: paginationModel?.page,
      perPage: paginationModel?.pageSize,
      filters: queryOptions,
    });
  };
  /*  const stateOptions = Object.entries(states).map(([value, label]) => ({
    value,
    label,
  })); */
  const handleDeleteSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.delete(
        `${process.env.REACT_APP_PUBLIC_API}/api/backlinks/${keyToDelete}`
      );
      if (response.status === 200) {
        console.log(
          `Row with ID ${keyToDelete} has been deleted successfully.`
        );
        // Update local state by filtering out the deleted row
        setBacklinksData((prevData) => {
          // Get the updated state data passed to the callback
          const updatedData = prevData.backlinksData?.filter(
            (backlink) => backlink.id !== keyToDelete
          );
          // Return the updated state data to update the local state
          return { ...prevData, backlinksData: updatedData };
        });
        toast.success("Backlink Deleted", { autoClose: 3000 });
        fetchBacklinksData({
          page: paginationModel?.page,
          perPage: paginationModel?.pageSize,
          filter: queryOptions,
        });
      } else {
        toast.error("Backlink couldn't be Deleted", { autoClose: 3000 });
        console.log(`Failed to delete row with ID ${keyToDelete}.`);
      }
    } catch (error) {
      console.error(`Error deleting row with ID ${keyToDelete}: ${error}`);
      toast.error(error.response.data.message);
    }
    setKeyToDelete("");
    handleModal();
  };

  const offset = (paginationModel?.page - 1) * paginationModel?.pageSize;
  const processRowUpdate = async (newRow, oldRow) => {
    setIsLoading(true);
    // updated field names
    const updatedRow = newRow;
    const createdRows = []; // Allow adding only one row at a time.
    const updatedRows = [];
    if (updatedRow?.isNew || updatedRow.records?.isNew) {
      createdRows.push({
        ...updatedRow,
        backlink_type_id: updatedRow?.backlink_type_id,
        ready_status_id: updatedRow?.ready_status_id,
        location_type: updatedRow?.location_type,
        location_ids: updatedRow?.location_ids,
        niche_product_ids: updatedRow?.niche_product_ids || "",
        isNew: undefined,
        customId: undefined,
      });
    } else {
      updatedRows.push({
        ...updatedRow,
        backlink_type_id: updatedRow?.backlink_type_id,
        ready_status_id: updatedRow?.ready_status_id,
        location_type: updatedRow?.location_type,
        location_ids: updatedRow?.location_ids,
        niche_product_ids: updatedRow?.niche_product_ids || "",
      });
    }

    try {
      // update+999999
      if (updatedRows.length) {
        // if(!updatedRows[0]["b.id"])
        //   return toast.error("backlink id is missing")
        api
          .put(
            `${process.env.REACT_APP_PUBLIC_API}/api/backlinks/updateBacklink`,
            {
              id: updatedRows[0]["b.id"],
              backlink_domain: updatedRows[0]["b.backlink_domain"],
              signup_url: updatedRows[0]["b.signup_url"] || "",
              backlink_location_type:
                updatedRows[0]["b.backlink_location_type"],
              backlink_type_id: updatedRows[0]["b.backlink_type_id"],
              domain_rating: updatedRows[0]["b.domain_rating"],
              ready_status_id: updatedRows[0]["b.ready_status_id"],
              follow_status: updatedRows[0]["b.follow_status"],
              backlink_rank: updatedRows[0]["b.backlink_rank"],
              traffic: updatedRows[0]["b.traffic"],
              good_to_assign: updatedRows[0]["b.good_to_assign"],
              niche_product_ids: updatedRows[0]["b.niche_product_ids"],
              location_type: updatedRows[0]["b.location_type"],
              location_ids: updatedRows[0]["b.location_ids"] ?? [
                updatedRows[0].row["b.location_ids"],
              ],
              backlink_paid_status: updatedRows[0]["b.backlink_paid_status"],
              is_verified: updatedRows[0]["b.is_verified"],
              spam_score: +updatedRows[0]["b.spam_score"],
              is_vip: updatedRows[0]["b.is_vip"],
            }
          )
          .then(() => {
            fetchBacklinksData({
              page: paginationModel?.page,
              perPage: paginationModel?.pageSize,
              filter: queryOptions,
            }); // Fetch updated data from the server and set it in local state
            setopenBacklink(false);
            toast.success("Backlink Updated", { autoClose: 3000 });
          })
          .catch((error) => {
            console.log(error);
            toast.error(error.response.data.message);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
      // create
      if (createdRows.length === 1) {
        api
          .post(
            `${process.env.REACT_APP_PUBLIC_API}/api/backlinks/addBacklink`,
            {
              backlink_domain: createdRows[0]["b.backlink_domain"],
              signup_url: createdRows[0]["b.signup_url"] || "",
              backlink_location_type:
                createdRows[0]["b.backlink_location_type"],
              backlink_type_id: createdRows[0]["b.backlink_type_id"],
              domain_rating: createdRows[0]["b.domain_rating"],
              ready_status_id: createdRows[0]["b.ready_status_id"],
              follow_status: createdRows[0]["b.follow_status"],
              backlink_rank: createdRows[0]["b.backlink_rank"],
              traffic: createdRows[0]["b.traffic"],
              niche_product_ids: createdRows[0]["b.niche_product_ids"],
              location_type: createdRows[0]["b.location_type"],
              location_ids: createdRows[0]["b.location_ids"],
              backlink_paid_status: createdRows[0]["b.backlink_paid_status"],
              is_verified: createdRows[0]["b.is_verified"],
              spam_score: createdRows[0]["b.spam_score"],
              is_vip: createdRows[0]["b.is_vip"],
            }
          )
          .then(() => {
            fetchBacklinksData({
              page: paginationModel?.page,
              perPage: paginationModel?.pageSize,
              filter: queryOptions,
            });
            setopenBacklink(false);
            toast.success("New Backlink Created!", { autoClose: 3000 });
          })
          .catch((error) => {
            console.log(error);
            toast.error(error.response.data.message);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
      return updatedRow;
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };
  /*   const CustomPagination = (props) => {
    const { paginationProps, api } = props;
    const handleLastPageClick = () => {
      api.setPage(api.state.pagination.pageCount);
    };
    return (
      <GridPagination
        {...paginationProps}
        showLastButton
        showFirstButton
        renderLastButton={(params) => (
          <button onClick={handleLastPageClick} disabled={params.disabled}>
            Last Page
          </button>
        )}
      />
    );
  }; */
  const rows = (backlinksData?.backlinksData || [])?.map((record, index) => {
    const counter = offset + index + 1;
    const records = record;
    const {
      "b.id": id,
      "b.backlink_domain": backlink_domain,
      "b.signup_url": signup_url,
      "b.type": type,
      "b.blacklisted": blacklisted,
      "b.domain_rating": domain_rating,
      "b.robot_group": robot_group,
      "b.ready_status": ready_status,
      "b.follow_status": follow_status,
      "b.traffic": traffic,
      "b.backlink_type_id": backlink_type_id,
      "b.ready_status_id": ready_status_id,
      "bds.total_inReview": total_inReview,
      "bds.total_hold": total_hold,
      "bds.total_completed": total_completed,
      "b.good_to_assign": good_to_assign,
      "b.niche_categories": niche_categories,
      "b.niche_product_ids": niche_product_ids,
      "b.location_type": location_type,
      "b.location_names": location_names,
      "b.location_ids": location_ids,
      "bds.total_cancelled": total_cancelled,
      "b.backlink_paid_status": backlink_paid_status,
      "b.is_verified": is_verified,
      "b.intersect_count": intersect_count,
      "b.spam_score": spam_score,
      "b.is_vip": is_vip,
    } = record;
    const source_domains_list_count =
      record["bi.source_domains_list"]?.split(",")?.length;
    const created_at = dayjs(record["b.created_at"]).format(
      "ddd, MMM D, YYYY h:mm A"
    );
    const updated_at = dayjs(record["b.updated_at"]).format(
      "ddd, MMM D, YYYY h:mm A"
    );

    return {
      counter,
      records,
      "b.id": id,
      "b.backlink_domain": backlink_domain,
      "b.signup_url": signup_url,
      "b.type": type || "",
      "b.blacklisted": blacklisted,
      "b.domain_rating": domain_rating,
      "b.robot_group": robot_group,
      "b.ready_status": ready_status || "",
      "b.follow_status": follow_status || "",
      "b.traffic": traffic,
      "b.backlink_type_id": backlink_type_id,
      "b.ready_status_id": ready_status_id,
      "bds.total_inReview": total_inReview,
      "bds.total_hold": total_hold,
      "bds.total_completed": total_completed,
      "b.good_to_assign": good_to_assign,
      "b.niche_categories": niche_categories,
      "b.niche_product_ids": niche_product_ids,
      "b.location_type": location_type,
      "b.location_names": location_names,
      "b.location_ids": location_ids,
      "b.created_at": created_at,
      "b.updated_at": updated_at,
      source_domains_list_count,
      "bds.total_cancelled": total_cancelled,
      "b.backlink_paid_status": backlink_paid_status,
      "b.is_verified": is_verified,
      "b.intersect_count": intersect_count,
      "b.spam_score": spam_score,
      "b.is_vip": is_vip,
    };
  });
  const handleNewFilter = () => {
    setPaginationModel({ pageSize: paginationModel.pageSize, page: 1 });
    let filters = {
      ...queryOptions,
      rules: queryOptions.rules.map((rule) => ({ ...rule })), // Deep copy of the rules
    };
    filters.rules.forEach((rule) => {
      if (rule.field === "bds.assigned_users") {
        rule.field = "bds.assigned_users";
        rule.op = rule.op === "Yes" ? "isNotEmpty" : "isEmpty";
      }
    });
    fetchBacklinksData({
      page: paginationModel?.page,
      perPage: paginationModel?.pageSize,
      filter: filters,
      ...(assignedStatus && { type: assignedStatus }),
    });
  };

  const processFilters = (filters) => {
    return (filters || []).map((filter) => {
      if (
        filter.operator === "isAnyOf" &&
        Array.isArray(filter.value) &&
        filter.value.length &&
        typeof filter.value[0] === "string" &&
        filter.value[0].includes(",")
      ) {
        return {
          ...filter,
          value: filter.value[0].split(",").map((item) => item.trim()),
        };
      }

      return filter;
    });
  };

  const operator = ({ operator, field }) => {
    const isSelect =
      columnDefs?.find((item) => item.field === field)?.type === "singleSelect";
    const isNumber =
      columnDefs?.find((item) => item.field === field)?.type === "number";
    const isDate =
      columnDefs?.find((item) => item.field === field)?.type === "date";
    return operator === "cn"
      ? "contains"
      : operator === "eq" && !isSelect && !isNumber
      ? "equals"
      : operator === "eq" && isSelect && !isNumber
      ? "is"
      : operator === "eq" && !isSelect && isNumber
      ? "="
      : operator === "not" && !isSelect && isNumber
      ? "!="
      : operator === "gt" && isDate
      ? "after"
      : operator === "gte" && isDate
      ? "onOrAfter"
      : operator === "lt" && isDate
      ? "before"
      : operator === "lte" && isDate
      ? "onOrBefore"
      : operator === "gt"
      ? ">"
      : operator === "gte"
      ? ">="
      : operator === "lt"
      ? "<"
      : operator === "lte"
      ? "<="
      : operator === "arraySize"
      ? "isEmpty"
      : operator;
  };

  const [filterModel, setFilterModel] = React.useState({
    items: queryOptions.rules?.map(({ field, op, data }) => ({
      field,
      operator: operator({ operator: op, field }),
      value: data,
      // data === true ? 1 : data === false ? 0 : data,
    })),
    logicOperator: "and",
    quickFilterValues: [],
    quickFilterLogicOperator: "and",
  });

  const onFilterChange = React.useCallback((filterModel) => {
    let ruless = [];
    const item = processFilters(filterModel.items);
    setFilterModel({
      ...filterModel,
      items: item,
    });
    if (filterModel?.items?.length === 0) {
      setAssignedStatus("");
      fetchBacklinksData({
        filter: [],
        page: 1,
        perPage: paginationModel.pageSize,
      });
    }
    // eslint-disable-next-line array-callback-return
    processFilters(filterModel.items)?.map((rule) => {
      const timeZoneOffset = new Date().getTimezoneOffset();
      const dynamicOffset =
        (timeZoneOffset > 0 ? "-" : "+") +
        String(Math.abs(timeZoneOffset) / 60).padStart(2, "0") +
        ":" +
        String(Math.abs(timeZoneOffset) % 60).padStart(2, "0");
      ruless = [
        ...ruless,
        {
          field: `${rule.field}`,
          op:
            rule.operator === "contains"
              ? "cn"
              : rule.operator === "equals"
              ? "eq"
              : rule.operator === "is"
              ? "eq"
              : rule.operator === "="
              ? "eq"
              : rule.operator === "!="
              ? "not"
              : rule.operator === ">"
              ? "gt"
              : rule.operator === ">="
              ? "gte"
              : rule.operator === "<"
              ? "lt"
              : rule.operator === "<="
              ? "lte"
              : rule.operator === "isEmpty"
              ? "eq"
              : rule.operator === "onOrBefore"
              ? "lte"
              : rule.operator === "before"
              ? "lt"
              : rule.operator === "onOrAfter"
              ? "gte"
              : rule.operator === "after"
              ? "gt"
              : rule.operator,
          data:
            rule.field === "b.niche_product_ids" && rule.value
              ? Array.isArray(rule.value)
                ? rule.value
                : [rule.value]
              : rule.field === "b.created_at" && rule.value
              ? `'${dayjs(rule.value)
                  .utcOffset(dynamicOffset) // Use the dynamic time zone offset
                  .format("YYYY-MM-DDTHH:mm:ssZ")}'`
              : rule.value
              ? rule.value
              : null,
        },
      ];
    });
    setQueryOptions({
      groupOp: filterModel.logicOperator.toUpperCase(),
      rules: ruless,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    "bds.assigned_users": false,
    //"b.backlink_type_id": false,
    "b.created_at": false,
    "b.updated_at": false,
    "ub.created_at": false,
  });
  const handleColumnVisibilityChange = (model) => {
    setColumnVisibilityModel(model);
  };

  /*   const getAssigned = async (status) => {
    await setAssignedStatus(status ? "assigned" : "notAssigned");
    fetchBacklinksData({
      user_id: user?.user?.id,
      is_assigned: status,
      type: status ? "assigned" : "notAssigned",
      page: paginationModel?.page,
      perPage: paginationModel?.pageSize,
      filter: queryOptions,
    });
  }; */
  /*  const existingCombinationsModal = (param = null) => {
    setExistCombiErros(param);
    setAlreadyAssignErrorModal(true);
  }; */
  const assignBacklinks = async (source = null, e, param = null) => {
    if (source) {
      e.preventDefault();
    }
    setIsLoading(true);
    const payload = {
      user_id: selectedUser?.id,
      backlink_ids: selectedData?.map((item) => item["b.id"]),
    };
    api
      .post(
        `${process.env.REACT_APP_PUBLIC_API}/api/domains/assign_backlinks_to_user`,
        payload
      )
      .then((res) => {
        setSelectedData([]);
        fetchBacklinksData({
          page: paginationModel?.page,
          perPage: paginationModel?.pageSize,
          filters: queryOptions,
        });
        toast.success(res?.data?.message || "Backlinks assigned successfully");
        setIsLoading(false);
      })
      .catch((err) => {
        /* if (err?.response?.data?.existingCombinations) {
          const dataArray = {
            errors: err?.response?.data?.existingCombinations || [],
            username: selectedUser?.username,
            message: err?.response?.data?.message || "",
          };
          existingCombinationsModal(dataArray);
          return;
        } */
        toast.error(err.response.data.message || "Something went wrong");
      });
    //if (source) setAlreadyAssignErrorModal(false);
    setIsLoading(false);
  };

  /*  const unassignBacklinks = () => {
    setIsLoading(true);
    const payload = {
      user_id: selectedUser?.id,
      backlink_ids: selectedData?.map((item) => item["b.id"]),
    };
    api
      .post(
        `${process.env.REACT_APP_PUBLIC_API}/api/backlinks/unassign_backlinks_from_user`,
        payload
      )
      .then((res) => {
        setSelectedData([]);
        fetchBacklinksData({
          filters: queryOptions,
          page: 1,
          size: paginationModel.pageSize,
        });
        toast.success(res?.data?.message);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
    setIsLoading(false);
  }; */

  const saveBlobAsExcelFile = (blobData) => {
    const downloadLink = window.URL.createObjectURL(new Blob([blobData]));

    const link = document.createElement("a");
    link.href = downloadLink;
    link.setAttribute("download", `backlinks.xlsx`); // Set the filename

    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadLink);
  };
  const downloadCSV = async () => {
    let filters = {
      ...queryOptions,
      rules: queryOptions.rules.map((rule) => ({ ...rule })), // Deep copy of the rules
    };
    filters.rules.forEach((rule) => {
      if (rule.field === "bds.assigned_users") {
        rule.field = "bds.assigned_users";
        rule.op = rule.op === "Yes" ? "isNotEmpty" : "isEmpty";
      }
    });
    const payload = {
      page: paginationModel?.page,
      perPage: paginationModel?.pageSize,
      filter: filters,
      user_id: user?.user?.id,
      is_assigned: true,
      assigned_user_id: selectedUser?.id || "",
      is_export: true,
    };
    setIsLoading(true);
    api
      .post(`${process.env.REACT_APP_PUBLIC_API}/api/backlinks/`, payload, {
        responseType: "blob",
      })
      .then((response) => {
        const blobData = response.data;
        saveBlobAsExcelFile(blobData);
        toast.success("backlinks export successfully");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Backlinks couldn't be export");
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const startBrowser = async () => {
    setOpenStartBrowser(!openStartBrowser);
  };

  const handleStartBrowser = async ({ domain, state_level = 0 }) => {
    if (!domain) {
      return toast.success("City name cannot be blank!");
    }
    setIsLoading(true);
    let profileId = null;
    try {
      const launchPayload = {
        os_type: osName === "Mac OS" ? "macos" : "windows",
        city: domain,
      };
      if (state_level === 1 || state_level === true) {
        launchPayload.state_level = state_level;
      }
      const launch = await api.post(
        "/api/multilogin/launch_browser_seo",
        launchPayload
      );
      if (launch.status === 200) {
        dispatch(setIsBrowserActive(1));
        dispatch(setIsBrowserDomain(domain));
        profileId = launch?.data?.profile_id;

        // Define a function to handle the URL launch
        const attemptUrlLaunch = async () => {
          const urlLaunch = await axios.get(launch.data.launchUrl, {
            headers: {
              Authorization: `Bearer ${launch.data.token}`,
              Accept: "application/json",
            },
            maxBodyLength: Infinity,
          });
          return urlLaunch;
        };

        let urlLaunch;
        try {
          urlLaunch = await attemptUrlLaunch();
        } catch (error) {
          if (
            error?.response?.data?.status?.error_code === "LOCK_PROFILE_ERROR"
          ) {
            // Unlock profile if needed
            await axios.get(
              "https://api.multilogin.com/bpds/profile/unlock_profiles",
              {
                headers: {
                  Authorization: `Bearer ${launch.data.token}`,
                  Accept: "application/json",
                },
              }
            );
            // Retry launching the URL after unlocking the profile
            urlLaunch = await attemptUrlLaunch();
          } else {
            throw error; // Rethrow error if it’s not a lock profile issue
          }
        }

        // Check response status and continue handling as in your original code
        if (urlLaunch.data.status.http_code === 200) {
          const update = await api.post(
            "/api/multilogin/update_browser_status_static_ip",
            {
              profile_id: profileId,
              is_browser_active: 1,
            }
          );
          if (update.status === 200) {
            toast.success("Browser started successfully");
          } else {
            dispatch(setIsBrowserActive(null));
            dispatch(setIsBrowserDomain(null));
            toast.error(
              update?.data?.message || "Browser status couldn't be updated"
            );
          }
        } else {
          // Handle other errors as in your original code
          console.log(urlLaunch.data.status.error_code, domain, profileId);
        }
      } else {
        dispatch(setIsBrowserActive(null));
        dispatch(setIsBrowserDomain(null));
        toast.error(launch?.data?.message || "Browser couldn't be launched.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      dispatch(setIsBrowserActive(null));
      dispatch(setIsBrowserDomain(null));
      handleApiError(error, domain);
    }
  };
  const handleApiError = (error, domain) => {
    if (error?.response?.data?.status?.error_code) {
      const errorMessage = error?.response?.data?.status?.error_code;
      if (
        errorMessage === "CORE_DOWNLOADING_STARTED" ||
        errorMessage === "CORE_DOWNLOADING_ALREADY_STARTED"
      ) {
        toast.error("Please try again after a minute", { autoClose: 10000 });
      } else if (errorMessage === "GET_PROXY_CONNECTION_IP_ERROR") {
        return handleStartBrowser({ domain, state_level: true });
      } else {
        toast.error(errorMessage || "Browser couldn't be launched.");
      }
    } else {
      toast.error("Proxy error: Could not proxy request!");
    }
    console.log("🚀 ~ file: index.jsx:252 ~ sendRequests ~ error:", error);
  };

  const handleBulkDelete = async () => {
    const ids = selectedData?.map((item) => item["b.id"]);

    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${
        ids?.length > 1 ? "these backlinks" : "this backlink"
      }?`
    );
    if (!confirmDelete) return;

    setIsLoading(true);
    try {
      const response = await api.delete(
        `${process.env.REACT_APP_PUBLIC_API}/api/backlinks/delete_backlinks`,
        {
          data: { ids },
        }
      );

      if (response.status === 200 || response.status === 201) {
        const message =
          ids?.length > 1 ? "Backlinks Deleted" : "Backlink Deleted";
        toast.success(message, { autoClose: 3000 });
        fetchBacklinksData({
          page: paginationModel?.page,
          perPage: paginationModel?.pageSize,
          filter: queryOptions,
        });
      } else {
        console.log("Failed to delete Backlink");
      }
    } catch (error) {
      console.error("Error deleting backlinks:", error);
      toast.error(
        error?.response?.data?.message ||
          "An error occurred while deleting backlinks."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const get_filters = async () => {
    try {
      const res = await api.get(
        "api/custom_filter?report_name=ASSIGN_BACKLINKS_TO_USER"
      );
      if (res.status === 200 || res.status === 201) {
        setSavedFilters(res?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const findMatchingObject = () => {
    return _.find(savedFilters, (item) => {
      if (item?.filter_json) {
        return _.isEqual(item?.filter_json, queryOptions);
      } else {
        return _.isEqual(item, queryOptions);
      }
    });
  };

  const isAllObjectMatched = () => {
    return savedFilters?.some((obj) => {
      if (obj?.filter_json?.groupOp !== queryOptions?.groupOp) return false;
      return queryOptions?.rules?.every((rule) =>
        obj?.filter_json?.rules?.some(
          (objRule) =>
            objRule?.field === rule?.field &&
            objRule?.op === rule?.op &&
            objRule?.data === rule?.data
        )
      );
    });
  };

  const sortUserFilters = (filters) => {
    if (!Array.isArray(filters)) {
      return [];
    }
    return filters.sort((a, b) => {
      const aStartsWithAsterisk = a.filter_name;
      const bStartsWithAsterisk = b.filter_name;

      if (aStartsWithAsterisk && !bStartsWithAsterisk) return -1;
      if (!aStartsWithAsterisk && bStartsWithAsterisk) return 1;
      return 0;
    });
  };
  const areObjectsEqual = (selectedFilter) => {
    return _.isEqual(selectedFilter, queryOptions);
  };

  const handleDeleteFilters = async (id) => {
    const c = window.confirm("Are you sure want to perform this action?");
    if (!c) return;

    setIsLoading(true);
    try {
      const res = await api.delete(`api/custom_filter/${id}`);
      if (res.status === 200) {
        get_filters();
        setFilterModel({
          items: [],
          logicOperator: "and",
          quickFilterValues: [],
          quickFilterLogicOperator: "and",
        });
        toast.success(
          res?.data?.error || res?.data?.message || "Filter saved successfully"
        );
        setQueryOptions({
          groupOp: "AND",
          rules: [],
        });
        fetchBacklinksData({
          page: paginationModel?.page,
          perPage: paginationModel?.pageSize,
        });
      } else {
        toast.error(
          res?.data?.error || res?.data?.message || "Filter couldn't saved"
        );
      }
      setIsLoading(false);
    } catch (err) {
      toast.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          "Filter couldn't saved"
      );
      console.log(err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (module === "backlink_from_user") {
      get_filters();
    } else if (!module || module === "") {
      setQueryOptions({
        groupOp: "AND",
        rules: [],
      });
      setFilterModel({
        items: [],
        logicOperator: "and",
        quickFilterValues: [],
        quickFilterLogicOperator: "and",
      });
      fetchBacklinksData({
        size: paginationModel.pageSize,
        page: paginationModel.page,
        filter: [],
      });
    }
  }, [module]);

  return (
    <div className="px-4 pt-0">
      {/* {isLoading && <Loading />} */}
      <div className="flex items-center justify-between">
        {!selectedUser ? (
          <CustomBreadcrumbs
            crumbs={[
              { label: "Home", link: "/" },
              { label: "Backlinks", link: "" },
            ]}
          />
        ) : (
          <CustomBreadcrumbs
            crumbs={[
              { label: "Home", link: "/" },
              { label: "Users", link: "/settings/users" },
              {
                label: ` Assign Backlinks to ${
                  selectedUser ? selectedUser?.name : ""
                }`,
                link: "",
              },
            ]}
          />
        )}
        {/*   <div className="flex flex-row">
          <button
            className="flex items-center gap-2 btnSecondary mr-1"
            onClick={() => setIsExcelImport(!isExcelImport)}
          >
            Update With Excel
          </button>
          {userPermission("Import Backlinks") ? (
            <button
              className="flex items-center gap-2 btnSecondary mr-1"
              onClick={() => setIsImport(!isImport)}
            >
              Import Backlinks
            </button>
          ) : null}
        </div> */}
      </div>

      {!isImport && (
        <ImportModal
          isImport={isImport}
          setOpen={setIsImport}
          //stateOptions={stateOptions}
          fetchBacklinksData={fetchBacklinksData}
        />
      )}
      {isFilterSave ? (
        <SaveFilterModal
          onClose={() => {
            setIsFilterSave(false);
          }}
          filters={queryOptions}
          reportName="ASSIGN_BACKLINKS_TO_USER"
          editingRecord={editingRecord}
          setFilters={() => {
            get_filters();
          }}
        />
      ) : null}
      {!isExcelImport && (
        <ImportUpdateExcelModal
          isExcelImport={isExcelImport}
          setOpen={setIsExcelImport}
          fetchBacklinksData={fetchBacklinksData}
        />
      )}

      {!isSourceDomain && (
        <SourceDomainModal
          domains={domains}
          setOpen={setIsSourceDomain}
          open={isSourceDomain}
        />
      )}

      {/*  {module && module === "backlink_from_user" ? (
        <div className="flex-cols md:flex flex-wrap justify-start space-x-2 mx-0.5 mt-3">
          <button
            type="button"
            disabled={!selectedData?.length}
            className={`text-sm py-2 px-4 rounded btnTable ${
              !selectedData?.length
                ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                : "bg-white text-black hover:bg-blue-700"
            } `}
            onClick={() => {
              assignBacklinks();
            }}
          >
            <MdAddCircleOutline size="20" className="mr-1" color="#48bb78" />
            ASSIGN BACKLINKS
          </button>
          <button
            type="button"
            disabled={!selectedData?.length}
            className={`text-sm py-2 px-4 rounded btnTable ${
              !selectedData?.length
                ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                : "bg-white text-black hover:bg-blue-700"
            } `}
            onClick={() => {
              unassignBacklinks();
            }}
          >
            <MdRemoveCircleOutline size="20" className="mr-1" color="#48bb78" />
            UNASSIGN BACKLINKS
          </button>

          <button
            type="button"
            className={`text-sm hover:bg-blue-700 py-2 px-4 rounded btnTable text-black ${
              assignedStatus === "assigned"
                ? "border-l-4 border-secondary bg-blue/10"
                : "bg-white"
            }
          `}
            onClick={(e) => getAssigned(true)}
          >
            Assigned
            <span className="bg-green-500 text-white px-2 py-1 rounded-md ml-2 text-xs">
              {backlinkCount ? backlinkCount?.assignedBacklinks : 0}
            </span>
          </button>
          <button
            type="button"
            className={`text-sm hover:bg-blue-700 py-2 px-4 rounded btnTable  text-black ${
              assignedStatus === "notAssigned"
                ? "border-l-4 border-secondary bg-blue/10"
                : "bg-white"
            }
          `}
            onClick={(e) => getAssigned(false)}
          >
            Not Assigned
            <span className="bg-green-500 text-white px-2 py-1 rounded-md ml-2 text-xs">
              {backlinkCount ? backlinkCount?.unassignedBacklinks : 0}
            </span>
          </button>
        </div>
      ) : null} */}
      <div className="bg-white my-3 border rounded">
        {module && module === "backlink_from_user" ? (
          <>
            <div className="flex gap-x-1 rounded w-fit ml-2 mt-2">
              <FiltersDropdown
                options={sortUserFilters(savedFilters)}
                value={findMatchingObject()}
                areObjectsEqual={(data) => areObjectsEqual(data)}
                handleDeleteFilters={(id) => handleDeleteFilters(id)}
                onEdit={(data) => {
                  setEditingRecord(data);
                  setIsFilterSave(true);
                }}
                onRemove={() => {
                  setQueryOptions({
                    groupOp: "AND",
                    rules: [],
                  });
                  setPaginationModel({
                    pageSize: paginationModel.pageSize,
                    page: 1,
                  });
                  setFilterModel({
                    items: [],
                    logicOperator: "and",
                    quickFilterValues: [],
                    quickFilterLogicOperator: "and",
                  });
                  setBacklinksData([]);
                  fetchBacklinksData({
                    size: paginationModel.pageSize,
                    page: paginationModel.page,
                    filter: [],
                  });
                  setSelectedData([]);
                }}
                onChange={(data) => {
                  const filters = data?.groupOp
                    ? data
                    : data?.filters
                    ? data.filters
                    : { groupOp: "AND", rules: [] };
                  setFilterModel({
                    items: filters?.rules?.map(({ field, op, data }) => ({
                      field: field,
                      operator: operator({ operator: op, field }),
                      value: data,
                    })),
                    logicOperator: "and",
                    quickFilterValues: [],
                    quickFilterLogicOperator: "and",
                  });
                  setQueryOptions(filters);
                  setPaginationModel({
                    pageSize: paginationModel.pageSize,
                    page: 1,
                  });
                  fetchBacklinksData({
                    filter: filters,
                    page: 1,
                    size: paginationModel.pageSize,
                  });
                }}
              />

              {queryOptions?.rules?.length && !isAllObjectMatched() ? (
                <div className="flex flex-row space-x-1">
                  <button
                    className="bg-secondary text-white w-[25px] h-[25px] rounded-full flex justify-center items-center mt-2"
                    onClick={() => setIsFilterSave(true)}
                  >
                    <FaCheck color="white" />
                  </button>
                </div>
              ) : null}
            </div>
          </>
        ) : null}
        <DataGrid
          initialState={{ pinnedColumns: { right: ["batch_action"] } }}
          rows={rows}
          columns={columnDefs}
          pinActions={true}
          components={{
            toolbar: ToolBar,
          }}
          componentsProps={{
            toolbar: {
              rowModesModel,
              setBacklinksData,
              setRowModesModel,
              fetchBacklinksData,
              paginationModel,
              setSelectedFilter,
              setPaginationModel,
              rows,
              selectedFilter,
              setIsLoading,
              handleNewFilter,
              backlinksData,
              selectedData,
              assignBacklinks,
              module,
              downloadCSV,
              openBacklink,
              setopenBacklink,
              setselectedEditRow,
              startBrowser,
              queryOptions,
              handleBulkDelete,
              bulkDelete: true,
            },
          }}
          editMode="row"
          getRowId={(row) => row["b.id"]}
          rowCount={backlinksData?.totalCount || 0}
          setRowModesModel={setRowModesModel}
          rowModesModel={rowModesModel}
          editable={true}
          pagination="No"
          processRowUpdate={processRowUpdate}
          setBacklinksData={setBacklinksData}
          handleDeleteSubmit={handleDeleteSubmit}
          onFilterModelChange={onFilterChange}
          fetchBacklinksData={refreshBacklinksData}
          columnVisibilityModel={columnVisibilityModel}
          handleColumnVisibilityChange={handleColumnVisibilityChange}
          queryOptions={queryOptions}
          setLocationdata={setLocationdata}
          resetPayload={resetPayload}
          setselectedEditRow={setselectedEditRow}
          handleBacklinkModal={handleBacklinkModal}
          height="80vh"
          loading={isLoader}
          module={module}
          filterModel={filterModel}
        />
      </div>
      <Modal
        open={!openBacklink}
        handleModal={handleBacklinkModal}
        cancelButtonRef={cancelBacklinkButtonRef}
        className="max-w-[70%]"
        title={selectededitRow ? "Edit Backlink" : "Create Backlink"}
      >
        <AddUpdateForm
          handleModal={handleBacklinkModal}
          isLoading={isLoading}
          nicheProductList={nicheProductList}
          followStatus={followStatus}
          backlinksStatusList={backlinksStatusList}
          backlinksTypeList={backlinksTypeList}
          processRowUpdate={processRowUpdate}
          selectededitRow={rows.find((e) => e["b.id"] === selectededitRow)}
        />
      </Modal>
      <Modal
        open={!isAlreadyAssignModal}
        handleModal={handleAlreadyAssignModal}
        cancelButtonRef={cancelButtonRef1}
        className="max-w-2xl"
        title={
          <span className="text-red-500 text-lg">
            Below backlinks are already assigned to{" "}
            {isExistCobmiErrors?.username}!
          </span>
        }
      >
        <AlreadyAssignErrorModal
          isExistCobmiErrors={isExistCobmiErrors}
          handleBacklinks={assignBacklinks}
          setAlreadyAssignErrorModal={setAlreadyAssignErrorModal}
          setSelectedData={setSelectedData}
        />
      </Modal>
      <Modal
        open={!openStartBrowser}
        handleModal={() => setOpenStartBrowser(false)}
        className="max-w-2xl"
        title={"Start Browser"}
      >
        <StartBrowser
          isLocation={isLocation}
          handleSelect={handleSelectDomain}
          handleQueryChange={handleQueryChange}
          setAutoComLoader={setAutoComLoader}
          isAutoComLoader={isAutoComLoader}
          selectedPayload={domain}
          setLocationdata={setLocationdata}
          handleModal={() => setOpenStartBrowser(false)}
          handleSubmit={() => handleStartBrowser({ domain: domain?.name })}
          setDomain={setDomain}
        />
      </Modal>
    </div>
  );
}
